import { useEffect, useState } from "react";
import http from "../services/http";

const useClientProfile = () => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchProfile = async () => {
    setLoading(true);
    const res = await http.get('/clients/me');
    const data = res.data?.data ?? res.data;
    setProfile(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchProfile();
  }, []);

  return { profile, refreshProfile: fetchProfile, loading };
};

export default useClientProfile;